'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HoverReveal = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    display: inline-block;\n    & > *:nth-child(2) {\n        display: none;\n    }\n    &:hover {\n        & > *:nth-child(1) {\n            display: none;\n        }\n        & > *:nth-child(2) {\n            display: inherit;\n        }\n    }\n'], ['\n    display: inline-block;\n    & > *:nth-child(2) {\n        display: none;\n    }\n    &:hover {\n        & > *:nth-child(1) {\n            display: none;\n        }\n        & > *:nth-child(2) {\n            display: inherit;\n        }\n    }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HoverReveal = exports.HoverReveal = _styledComponents2.default.div(_templateObject);
HoverReveal.displayName = 'HoverReveal';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/HoverReveal.js
// module id = 241
// module chunks = 0